import React, { useState } from "react";
import { Auth0Provider, useAuth0 } from "@auth0/auth0-react";
import Navbar from "./components/Navbar";
import DashboardPage from "./pages/DashboardPage";
import CasinoPage from "./pages/CasinoPage";
import TransactionPage from "./pages/TransactionPage";
import AlertPage from "./pages/AlertPage";
import DirectoryPage from "./pages/DirectoryPage";
import ProfilePage from "./pages/ProfilePage";
import SessionPage from "./pages/SessionPage";
import ContactUsPage from "./pages/ContactUsPage";
import LoginPage from './pages/LoginPage';
import ArchivePage from './pages/ArchivedPage';
import { UserProvider } from "./contexts/UserContext";

// Auth0 configuration
const auth0Config = {
  domain: "dev-vl0p7rik3k4xbxjh.us.auth0.com",
  clientId: "J5nBxzzDbFdSWJiuW8R04LrbTaoqO0JZ",
  authorizationParams: {
    redirect_uri: window.location.origin,
  }
};


// AppContent component handles the authentication state and routing
const AppContent = () => {
  const { isAuthenticated, isLoading } = useAuth0();
  const [currentPage, setCurrentPage] = useState("dashboard");


  // Show login page if not authenticated
  if (!isAuthenticated) {
    return <LoginPage />;
  }

  // Render the appropriate page based on currentPage state
  const renderPage = () => {
    switch (currentPage) {
      case "dashboard":
        return <DashboardPage />;
      case "casino":
        return <CasinoPage />;
      case "transaction":
        return <TransactionPage />;
      case "alert":
        return <AlertPage />;
      case "directory":
        return <DirectoryPage />;
      case "profile":
        return <ProfilePage />;
      case "session":
        return <SessionPage />;
      case "contactUs":
        return <ContactUsPage />;
      case "archive":
        return <ArchivePage />
      default:
        return <DashboardPage />;
    }
  };

  // Return the main application layout when authenticated
  return (
    <div className="flex h-screen overflow-hidden">
      <Navbar currentPage={currentPage} onPageChange={setCurrentPage} />
      <main className="flex-1 overflow-y-auto pt-16 lg:pt-0">
        {renderPage()}
      </main>
    </div>
  );
};

// Main App component wraps everything with necessary providers
const App = () => {
  return (
    <Auth0Provider {...auth0Config}>
      <UserProvider>
        <AppContent />
      </UserProvider>
    </Auth0Provider>
  );
};

export default App;